export const searchByData = [
	{
		id: 0,
		name: "name",
		option: {
			en: "By Name",
			ko: "이름별",
			zh: "按名称",
		},
	},
	{
		id: 1,
		name: "capital",
		option: {
			en: "By Capital",
			ko: "수도별",
			zh: "按首都",
		},
	},
	{
		id: 2,
		name: "continets",
		option: {
			en: "By Continets",
			ko: "대륙별",
			zh: "按洲",
		},
	},
	{
		id: 3,
		name: "language",
		option: {
			en: "By Language",
			ko: "언어",
			zh: "语言",
		},
	},
];

export const placeHolder = {
	en: "Search...",
	ko: "검색...",
	zh: "搜索...",
};
